import { type TokenAudience, cdnFinalizeLoginHook } from '@heimdall/client';

const wsDefaultAudiences: TokenAudience[] = ['api.ws', 'data.ws'];

export const defaultAudiencesByClientUid: Record<string, TokenAudience[]> = {
  workspace: wsDefaultAudiences,
  lseg_teams: wsDefaultAudiences,
  lseg_teams_dev: wsDefaultAudiences,
  lseg_teams_local: wsDefaultAudiences,
  lseg_teams_ppe: wsDefaultAudiences,
  lseg_teams_qa: wsDefaultAudiences,
};

export const knownLinkOrigins: Record<string, string> = {
  c: 'https://cdn.refinitiv.com',
  c_ppe: 'https://cdn.ppe.refinitiv.com',
  c_qa: 'https://cdn.qa.refinitiv.com',

  cx: 'https://cdn.extranet.refinitiv.biz',
  cx_asia: 'https://apac1-cdn.extranet.refinitiv.biz',
  cx_asia_ppe: 'https://apac1-cdn.ppe.extranet.refinitiv.biz',
  cx_eu: 'https://emea1-cdn.extranet.refinitiv.biz',
  cx_eu_ppe: 'https://emea1-cdn.ppe.extranet.refinitiv.biz',
  cx_eu_qa: 'https://emea1-cdn.qa.extranet.refinitiv.biz',
  cx_ppe: 'https://cdn.ppe.extranet.refinitiv.biz',
  cx_qa: 'https://cdn.qa.extranet.refinitiv.biz',
  cx_us1: 'https://amers1-cdn.extranet.refinitiv.biz',
  cx_us1_ppe: 'https://amers1-cdn.ppe.extranet.refinitiv.biz',
  cx_us1_qa: 'https://amers1-cdn.qa.extranet.refinitiv.biz',

  w: 'https://workspace.refinitiv.com',
  w_ppe: 'https://workspace.ppe.refinitiv.com',
  w_qa: 'https://workspace.qa.refinitiv.com',

  wx: 'https://workspace.extranet.refinitiv.biz',
  wx_asia: 'https://apac1-workspace.extranet.refinitiv.biz',
  wx_eu: 'https://emea1-workspace.extranet.refinitiv.biz',
  wx_eu_ppe: 'https://emea1-workspace.ppe.extranet.refinitiv.biz',
  wx_ppe: 'https://workspace.ppe.extranet.refinitiv.biz',
  wx_us1: 'https://amers1-workspace.extranet.refinitiv.biz',
  wx_us1_ppe: 'https://amers1-workspace.ppe.extranet.refinitiv.biz',
  wx_us2: 'https://amers2-workspace.extranet.refinitiv.biz',

  zloc_3r: 'http://thirdparty.local:8080',
  zloc_3rds: 'https://thirdparty.local:8081',
  zloc_lh: 'http://localhost:8080',
};

// hook now lives in @heimdall/client; re-export for the redirect call-sites.
export const workspaceFinalizeLoginHook = cdnFinalizeLoginHook;
